// extracted by mini-css-extract-plugin
module.exports = {"cursorMain":"CustomCursor_cursorMain__33Kz0","cursorText":"CustomCursor_cursorText__2SQTp","textCursor":"CustomCursor_textCursor__oZp8j"};